import { toast } from 'react-toastify';

const TOAST_STORAGE_KEY = 'pending_toast';

export const queueToast = (type: 'success' | 'error' | 'info' | 'warning', message: string) => {
    sessionStorage.setItem(TOAST_STORAGE_KEY, JSON.stringify({ type, message }));
};

export const showPendingToast = () => {
    const pendingToast = sessionStorage.getItem(TOAST_STORAGE_KEY);
    if (pendingToast) {
        const { type, message } = JSON.parse(pendingToast);
        
        setTimeout(() => {
            toast[type](message);
            sessionStorage.removeItem(TOAST_STORAGE_KEY);
        }, 50);
    }
};